export default {
  "content": "<circle cx=\"44\" cy=\"44\" r=\"44\" fill=\"#000\" fill-opacity=\".9\"/><path d=\"M47.79 40.306h-8.106l1.587-7.187h6.864c2.806 0 4.43 1.279 4.43 3.397 0 2.509-1.968 3.79-4.774 3.79zm-2.904 14.62h-8.433l1.86-8.417h6.869c3.396 0 5.464 1.426 5.464 3.986 0 2.608-2.116 4.43-5.76 4.43zm15.604-19.64c0-4.681-3.561-7.72-8.458-8.597l.852-4.051a1.399 1.399 0 00-1.369-1.685h-5.159c-.66 0-1.23.46-1.367 1.106l-.93 4.366h-8.472c-.491 0-.917.34-1.023.82l-7.301 33.052a1.048 1.048 0 001.023 1.274h7.97l-.798 3.748a1.4 1.4 0 001.357 1.69l5.167.039a1.4 1.4 0 001.38-1.113l.916-4.364h.804c8.27 0 13.537-4.53 13.537-10.386 0-3.446-1.87-6.252-4.774-7.68 3.643-1.033 6.645-3.938 6.645-8.22\" fill=\"#fff\"/>",
  "attrs": {
    "width": "88",
    "height": "88",
    "viewBox": "0 0 88 88",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};